import React from 'react';
import SpinnerStyled from './SpinnerStyled';

function Spinner() {
  return (
    <SpinnerStyled>
      <div className="spinner"></div>
    </SpinnerStyled>
  );
}

export default Spinner;
